import { render, staticRenderFns } from "./language_codes.vue?vue&type=template&id=2e531532&scoped=true&"
import script from "./language_codes.vue?vue&type=script&lang=js&"
export * from "./language_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e531532",
  null
  
)

export default component.exports